import { Stack, Typography, Box, FormControl, RadioGroup, FormControlLabel, Radio } from "@mui/material";
import { useTranslation } from "react-i18next";
import { HolidayExtent } from "../../../types/holidayExtent";

export type RegionalHolidaysState = {
  holy3KingsDay: HolidayExtent;
  internationalWomensHoliday: HolidayExtent;
  fronleichnamHoliday: HolidayExtent;
  mariaHimmelfahrtHoliday: HolidayExtent;
  worldChildrenDayHoliday: HolidayExtent;
  reformationDayHoliday: HolidayExtent;
  allerheiligenDayHoliday: HolidayExtent;
  bussUndBetTagHoliday: HolidayExtent;
  augsburgerFriedensfestHoliday: HolidayExtent;
  christmasEveHoliday: HolidayExtent;
  newYearsEveHoliday: HolidayExtent;
  easterSundayHoliday: HolidayExtent;
  pfingstSundayHoliday: HolidayExtent;
};

interface RegionalHolidaysProps {
  value: RegionalHolidaysState;
  onUpdate: (value: RegionalHolidaysState) => void;
}

export function RegionalHolidays(props: RegionalHolidaysProps) {
  const { t } = useTranslation();

  return <Stack spacing={1}>
    <Typography variant="subtitle1">
      {t("employeesPage.workTimeQuota.regionalHolidays")}
    </Typography>

    <HolidayToggle
      label={t("employeesPage.workTimeQuota.holidays.augsburgerFriedensfest")}
      onChange={(holiday) => props.onUpdate({ ...props.value, augsburgerFriedensfestHoliday: holiday })}
      value={props.value.augsburgerFriedensfestHoliday} />

    <HolidayToggle
      label={t("employeesPage.workTimeQuota.holidays.christmasEve")}
      onChange={(holiday) => props.onUpdate({ ...props.value, christmasEveHoliday: holiday })}
      value={props.value.christmasEveHoliday} />

    <HolidayToggle
      label={t("employeesPage.workTimeQuota.holidays.newYearsEve")}
      onChange={(holiday) => props.onUpdate({ ...props.value, newYearsEveHoliday: holiday })}
      value={props.value.newYearsEveHoliday} />

    <HolidayToggle
      label={t("employeesPage.workTimeQuota.holidays.fronleichnam")}
      onChange={(holiday) => props.onUpdate({ ...props.value, fronleichnamHoliday: holiday })}
      value={props.value.fronleichnamHoliday} />

    <HolidayToggle
      label={t("employeesPage.workTimeQuota.holidays.allerheiligen")}
      onChange={(holiday) => props.onUpdate({ ...props.value, allerheiligenDayHoliday: holiday })}
      value={props.value.allerheiligenDayHoliday} />

    <HolidayToggle
      label={t("employeesPage.workTimeQuota.holidays.internationalWomensHoliday")}
      onChange={(holiday) => props.onUpdate({ ...props.value, internationalWomensHoliday: holiday })}
      value={props.value.internationalWomensHoliday} />

    <HolidayToggle
      label={t("employeesPage.workTimeQuota.holidays.reformationDay")}
      onChange={(holiday) => props.onUpdate({ ...props.value, reformationDayHoliday: holiday })}
      value={props.value.reformationDayHoliday} />

    <HolidayToggle
      label={t("employeesPage.workTimeQuota.holidays.bussUndBetTag")}
      onChange={(holiday) => props.onUpdate({ ...props.value, bussUndBetTagHoliday: holiday })}
      value={props.value.bussUndBetTagHoliday} />

    <HolidayToggle
      label={t("employeesPage.workTimeQuota.holidays.holy3KingsDay")}
      onChange={(holiday) => props.onUpdate({ ...props.value, holy3KingsDay: holiday })}
      value={props.value.holy3KingsDay} />

    <HolidayToggle
      label={t("employeesPage.workTimeQuota.holidays.mariaHimmelfahrt")}
      onChange={(holiday) => props.onUpdate({ ...props.value, mariaHimmelfahrtHoliday: holiday })}
      value={props.value.mariaHimmelfahrtHoliday} />

    <HolidayToggle
      label={t("employeesPage.workTimeQuota.holidays.worldChildrenDay")}
      onChange={(holiday) => props.onUpdate({ ...props.value, worldChildrenDayHoliday: holiday })}
      value={props.value.worldChildrenDayHoliday} />

    <HolidayToggle
      label={t("employeesPage.workTimeQuota.holidays.easterSunday")}
      onChange={(holiday) => props.onUpdate({ ...props.value, easterSundayHoliday: holiday })}
      value={props.value.easterSundayHoliday} />

    <HolidayToggle
      label={t("employeesPage.workTimeQuota.holidays.pfingstSunday")}
      onChange={(holiday) => props.onUpdate({ ...props.value, pfingstSundayHoliday: holiday })}
      value={props.value.pfingstSundayHoliday} />
  </Stack>
}

interface HolidayToggleProps {
  label: string;
  value: HolidayExtent | null;
  onChange: (value: HolidayExtent) => void;
}

function HolidayToggle(props: HolidayToggleProps) {
  const { t } = useTranslation();

  return <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 2 }}>
    <Typography variant="body1">
      {props.label}
    </Typography>
    <FormControl>
      <RadioGroup row
        value={props.value ?? HolidayExtent.None}
        onChange={(event) => {
          let holiday: HolidayExtent = parseInt(event.target.value);
          props.onChange(holiday);
        }}>
        <FormControlLabel control={<Radio />}
          value={HolidayExtent.None}
          label={t("holidayExtent.none")} />
        <FormControlLabel control={<Radio />}
          value={HolidayExtent.Half}
          label={t("holidayExtent.half")} />
        <FormControlLabel control={<Radio />}
          value={HolidayExtent.Full}
          label={t("holidayExtent.full")} />
      </RadioGroup>
    </FormControl>
  </Box>
}